import Barba from '@barba/core';
import barbaCss from '@barba/css';
import debounce from './utilities/debounce';
import Menu from './sections/menu';
import ProjectInfo from './sections/project-info';
import homeProjectsSection from './sections/home-projects';
import workshopsSection from './sections/workshops';
import shopSection from './sections/shop';

// Stick figure details to the bottom of the image
const positionArtworkDetails = context => {
  const artworkDetails = context.querySelectorAll('figure div');
  artworkDetails.forEach(div => {
    const image = div.parentElement.querySelector('img');
    if (image) {
      const bottom = image.offsetTop + image.clientHeight;
      div.style.top = `${bottom}px`;
      div.style.visibility = 'visible';
    }
  });
}

// Barba transitions
Barba.use(barbaCss);
Barba.init({
  // cacheIgnore: true,
  timeout: 5000
});

// Hook after load
Barba.hooks.after(data => pageEntered(data));

// Menu
window.menu = new Menu(Barba);

// Project info
window.projectInfo = new ProjectInfo();

// Page has been entered
const pageEntered = data => {
  const context = data.next ? data.next.container : document.getElementById('content');
  
  // Destroy any fullPage instances
  if (window.fullPage) {
    window.fullPage.destroy('all');
    window.fullPage = null;
  }

  // Close the menu
  window.menu.close();

  // Back to top
  let backToTopLink = document.getElementById('back-to-top');
  if (backToTopLink) backToTopLink.addEventListener('click', event => {
    event.preventDefault();
    document.getElementById('scroll-top').scrollIntoView({ behavior: 'smooth' });
  });

  // Set background color to body
  document.body.style.backgroundColor = context.dataset.bgcolor;

  // Call section scripts for context
  if (context.classList.contains('section-home')) {
    homeProjectsSection(context);
  } else if (context.classList.contains('section-workshops-page')) {
    workshopsSection(context);
  } else if (context.classList.contains('section-shop')) {
    shopSection(context);
  }

  // Fix artwork details on all figures
  positionArtworkDetails(context);

  // Refresh the projects info
  window.projectInfo.initButtons();

  // Destroy any tranasition cover images
  let cover = document.getElementById('transitionCoverImage');
  if (cover) cover.remove();

  // Always go to top of page after page transition
  document.getElementById('scroll-top').scrollIntoView();
}

// Document ready for first load
window.addEventListener('load', pageEntered);

// Resize
window.addEventListener('resize', debounce(() => {
  positionArtworkDetails(document); 
}));

// Scroll
window.addEventListener('scroll', debounce(() => {
  positionArtworkDetails(document); 
}));



// WEBPACK FOOTER //
// ./source/javascript/main.js